import React from "react";
import UserHandler from "js/utilities/user-handler";
import { Link } from "react-router";

export default React.createClass({
  displayName: "get-display-appName",

  getInitialState: function() {
    var appName = "Temporary Application Name";
    return {appName : appName};
  },
  buildLine: function() {
    if (!this.state.appName) {
      if (this.props.link) {
        return <Link className={this.props.className} to={this.props.link}> {this.props.prompt}</Link>
      }
      else {
        return this.props.prompt;
      }
    }
    else {
      return this.state.appName;
    }
  },

  render: function() {

    return (
      <span >
        {this.buildLine()}
      </span>
    )
  }
});



// WEBPACK FOOTER //
// ./src/js/utilities/get-display-appname.jsx